import { login as enLogin } from '../en-us/login';

export const login = {
  ...enLogin,
  header: 'Falsche E-Mail-Adresse oder Passwort',
  description:
    'Nutze bitte die Daten, die du bei deiner ersten Bestellung oder beim Erstellen deines Kontos verwendet hast.'
};
